"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/ethereum-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 5.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1Api = exports.V1ApiFactory = exports.V1ApiFp = exports.V1ApiAxiosParamCreator = exports.ValidationErrorMessageEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var ValidationErrorMessageEnum;
(function (ValidationErrorMessageEnum) {
    ValidationErrorMessageEnum["ValidationFailed"] = "Validation failed";
})(ValidationErrorMessageEnum = exports.ValidationErrorMessageEnum || (exports.ValidationErrorMessageEnum = {}));
/**
 * V1Api - axios parameter creator
 * @export
 */
const V1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get the estimated gas cost of a transaction
         * @param {string} data input data
         * @param {string} from from address
         * @param {string} to to address
         * @param {string} value transaction value in wei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateGas: (data, from, to, value, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'data' is not null or undefined
            common_1.assertParamExists('estimateGas', 'data', data);
            // verify required parameter 'from' is not null or undefined
            common_1.assertParamExists('estimateGas', 'from', from);
            // verify required parameter 'to' is not null or undefined
            common_1.assertParamExists('estimateGas', 'to', to);
            // verify required parameter 'value' is not null or undefined
            common_1.assertParamExists('estimateGas', 'value', value);
            const localVarPath = `/api/v1/gas/estimate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get account details by address
         * @param {string} pubkey account address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: (pubkey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pubkey' is not null or undefined
            common_1.assertParamExists('getAccount', 'pubkey', pubkey);
            const localVarPath = `/api/v1/account/{pubkey}`
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGasFees: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/gas/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get information about the running coinstack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/v1/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get transaction history by address
         * @param {string} pubkey account address
         * @param {number} [page] page number
         * @param {number} [pageSize] page size
         * @param {string} [contract] filter by contract address (only supported by coins which support contracts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHistory: (pubkey, page, pageSize, contract, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pubkey' is not null or undefined
            common_1.assertParamExists('getTxHistory', 'pubkey', pubkey);
            const localVarPath = `/api/v1/account/{pubkey}/txs`
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (contract !== undefined) {
                localVarQueryParameter['contract'] = contract;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Sends raw transaction to be broadcast to the node.
         * @param {SendTxBody} sendTxBody serialized raw transaction hex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTx: (sendTxBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sendTxBody' is not null or undefined
            common_1.assertParamExists('sendTx', 'sendTxBody', sendTxBody);
            const localVarPath = `/api/v1/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(sendTxBody, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.V1ApiAxiosParamCreator = V1ApiAxiosParamCreator;
/**
 * V1Api - functional programming interface
 * @export
 */
const V1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.V1ApiAxiosParamCreator(configuration);
    return {
        /**
         * Get the estimated gas cost of a transaction
         * @param {string} data input data
         * @param {string} from from address
         * @param {string} to to address
         * @param {string} value transaction value in wei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateGas(data, from, to, value, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.estimateGas(data, from, to, value, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get account details by address
         * @param {string} pubkey account address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(pubkey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccount(pubkey, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGasFees(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGasFees(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get information about the running coinstack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInfo(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get transaction history by address
         * @param {string} pubkey account address
         * @param {number} [page] page number
         * @param {number} [pageSize] page size
         * @param {string} [contract] filter by contract address (only supported by coins which support contracts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHistory(pubkey, page, pageSize, contract, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTxHistory(pubkey, page, pageSize, contract, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Sends raw transaction to be broadcast to the node.
         * @param {SendTxBody} sendTxBody serialized raw transaction hex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTx(sendTxBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendTx(sendTxBody, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.V1ApiFp = V1ApiFp;
/**
 * V1Api - factory interface
 * @export
 */
const V1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.V1ApiFp(configuration);
    return {
        /**
         * Get the estimated gas cost of a transaction
         * @param {string} data input data
         * @param {string} from from address
         * @param {string} to to address
         * @param {string} value transaction value in wei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateGas(data, from, to, value, options) {
            return localVarFp.estimateGas(data, from, to, value, options).then((request) => request(axios, basePath));
        },
        /**
         * Get account details by address
         * @param {string} pubkey account address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(pubkey, options) {
            return localVarFp.getAccount(pubkey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGasFees(options) {
            return localVarFp.getGasFees(options).then((request) => request(axios, basePath));
        },
        /**
         * Get information about the running coinstack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options) {
            return localVarFp.getInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Get transaction history by address
         * @param {string} pubkey account address
         * @param {number} [page] page number
         * @param {number} [pageSize] page size
         * @param {string} [contract] filter by contract address (only supported by coins which support contracts)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHistory(pubkey, page, pageSize, contract, options) {
            return localVarFp.getTxHistory(pubkey, page, pageSize, contract, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends raw transaction to be broadcast to the node.
         * @param {SendTxBody} sendTxBody serialized raw transaction hex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTx(sendTxBody, options) {
            return localVarFp.sendTx(sendTxBody, options).then((request) => request(axios, basePath));
        },
    };
};
exports.V1ApiFactory = V1ApiFactory;
/**
 * V1Api - object-oriented interface
 * @export
 * @class V1Api
 * @extends {BaseAPI}
 */
class V1Api extends base_1.BaseAPI {
    /**
     * Get the estimated gas cost of a transaction
     * @param {V1ApiEstimateGasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    estimateGas(requestParameters, options) {
        return exports.V1ApiFp(this.configuration).estimateGas(requestParameters.data, requestParameters.from, requestParameters.to, requestParameters.value, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get account details by address
     * @param {V1ApiGetAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getAccount(requestParameters, options) {
        return exports.V1ApiFp(this.configuration).getAccount(requestParameters.pubkey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getGasFees(options) {
        return exports.V1ApiFp(this.configuration).getGasFees(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get information about the running coinstack
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getInfo(options) {
        return exports.V1ApiFp(this.configuration).getInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get transaction history by address
     * @param {V1ApiGetTxHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getTxHistory(requestParameters, options) {
        return exports.V1ApiFp(this.configuration).getTxHistory(requestParameters.pubkey, requestParameters.page, requestParameters.pageSize, requestParameters.contract, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sends raw transaction to be broadcast to the node.
     * @param {V1ApiSendTxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    sendTx(requestParameters, options) {
        return exports.V1ApiFp(this.configuration).sendTx(requestParameters.sendTxBody, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.V1Api = V1Api;
